import { AnalyticsProvider } from '../analytics-provider';
import clarity from '@microsoft/clarity';
import { environment } from '../../../../environments/environment';
import { signal } from '@angular/core';

export class ClarityProvider implements AnalyticsProvider {
  private static readonly API_KEY = environment.clarityApiKey;

  private _active = signal<boolean>(false);
  private _initialized = signal<boolean>(false);

  get active() {
    return this._active.asReadonly();
  }

  get initialized() {
    return this._initialized.asReadonly();
  }

  get id() {
    return 'clarity';
  }

  activate(): void {
    if (!this._initialized()) {
      return;
    }

    clarity.consentV2({
      ad_Storage: 'granted',
      analytics_Storage: 'granted',
    });

    this._active.set(true);
  }

  deactivate(): void {
    if (!this._initialized()) {
      return;
    }

    clarity.consentV2({
      ad_Storage: 'denied',
      analytics_Storage: 'denied',
    });

    this._active.set(false);
  }

  initialize(): void {
    if (!ClarityProvider.API_KEY) {
      return;
    }

    if (this._initialized()) {
      return;
    }

    clarity.init(ClarityProvider.API_KEY);
    this._initialized.set(true);

    this.deactivate();
  }
}
